<template>
    <bottom-sheet title="付款方式" @onClose="onClose" :no-btn="true">
        <div class="normal" v-show="! overTenThousand && !isPay">
            <label class="item" v-show="! overTwoThousand && !onlyOnline">
                <div class="icon">
                    <img src="@/assets/img/credit/cash.png">
                </div>
                <div class="title">現金付款</div>
                <div class="button">
                    <p-radio name="type" value="cash" v-model="type"/>
                </div>
            </label>
            <div class="item" v-show="overTwoThousand">
                <div class="title red">
                    訂單超過 $2000，請使用信用卡付款
                </div>
            </div>
            <label class="item">
                <div class="icon">
                    <img src="@/assets/img/credit/card.png">
                </div>
                <div class="title">使用新的信用卡</div>
                <div class="button">
                    <p-radio name="type" value="credit" v-model="type"/>
                </div>
            </label>
            <div class="agreement-list">
                <label class="item" v-for="agreement in agreements" :key="agreement.id">
                    <div class="icon">
                        <img v-if="agreement.type === 'jcb'" src="@/assets/img/credit/jcb.png">
                        <img v-else-if="agreement.type === 'visa'" src="@/assets/img/credit/visa.png">
                        <img v-else-if="agreement.type === 'master'" src="@/assets/img/credit/mastercard.png">
                        <img v-else src="@/assets/img/credit/card.png">
                    </div>
                    <div class="title">**** {{ agreement.card_suffix }}</div>
                    <div class="button">
                        <p-radio name="type" :value="agreement.id" v-model="type"/>
                    </div>
                </label>
            </div>
        </div>
        <div class="ten-thousand" v-show="overTenThousand && !isPay">
            {{ donate ? '打賞' : '訂單' }}超過 $5000，需要使用信用卡支付
        </div>
        <div class="ten-thousand" v-show="isPay">
            代付服務需要使用信用卡支付
        </div>
        <div class="pay-btn">
            <div class="right" @click="onPay">
                <span>確定</span>
            </div>
        </div>
    </bottom-sheet>
</template>

<script>
    import BottomSheet from '../BottomSheet';
    import PRadio from '../RadioButton';
    import { mapGetters } from 'vuex';

    export default {
        name: 'SelectPaymentType',
        components: {
            'bottom-sheet': BottomSheet,
            'p-radio': PRadio,
        },
        props: {
            onlyOnline: {
                default: false,
            },
            payment: {
                required: true,
            },
            isPay: {
                default: false,
            },
            donate: {
                default: 0,
            }
        },
        data() {
            return {
                type: 'cash',
                isLoading: false,
                errMsg: '',
                creditWindos: null,
                checkWin: null,
            }
        },
        computed: {
            overTwoThousand() {
                return this.donate > 0 ? false : (this.cartPriceTotal + Math.round(((this.cartExpectedPrice || 0) + this.cartProductPrice) * 0.03)) > 2000;
            },
            overTenThousand() {
                return this.donate <= 0 ? (this.cartPriceTotal + Math.round(((this.cartExpectedPrice || 0) + this.cartProductPrice) * 0.03)) >= 5000 : this.donate >= 5000;
            },
            ...mapGetters(['cartPrice', 'cartExpectedPrice', 'agreements', 'cartProductPrice', 'cartPriceTotal']),
        },
        methods: {
            onPay() {
                if (this.overTenThousand || this.isPay) {
                    this.type = 'credit';
                }

                this.$emit('selectPayment', this.type);
                this.$emit('onClose');
            },
            onClose() {
                this.$emit('onClose');
            },
        },
        created() {
            this.type = this.payment;
        }
    };
</script>

<style lang="scss" scoped>
    .item {
        display: flex;
        align-items: center;
        border: 1px solid rgba(221,221,221,1);
        border-radius: 4px;
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 14px;
        line-height: 20px;
        padding: 0 10px;
        margin-top: 10px;
        height: 36px;

        .icon {
            width: 40px;
            margin-right: 10px;
        }

        .title {
            width: 100%;
            text-align: left;

            &.red {
                color: rgba(244,67,54,1);
            }
        }
    }

    .ten-thousand {
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(244,67,54,1);
        height: 100px;
    }

    .pay-btn {
        display: flex;
        height: 45px;

        .right {
            display: flex;
            box-shadow: 0 0 2px 0 rgba(51,153,51,0.35);
            background-color: rgba(51,153,51,1);
            border-radius: 35px;
            width: 100%;
            padding: 0 12px;
            color: rgba(255,255,255,1);
            font-family: "PingFang TC";
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            align-items: center;

            span {
                width: 100%;
            }

            img {
                width: 20px;
                height: 20px;
            }
        }
    }

    .agreement-list {
        min-height: 10vh;
        max-height: 25vh;
        overflow-y: auto;
    }

    .info {
        .tip {
            color: gray;
        }

        .detail {
            margin: 10px 20px 20px 20px;

            .row {
                display: flex;
                justify-content: space-between;
            }
        }
    }
</style>
